import {createApp} from 'vue/dist/vue.esm-bundler';
import App from './App.vue';
import {createRouter, createWebHashHistory} from 'vue-router';
import {ROUTES} from '@/routes';
import axios from 'axios';
import {getRelativeTime} from '@/helpers/datetime';
import {useStore} from '@/helpers/store-effect';
import {dragscrollNext} from 'vue-dragscroll';
import {useConfig} from '@/helpers/config-effect';
import {ConnectionProvider, useConnections} from '@/helpers/connections-effect';
import ErrorWrapper from '@/components/workflows/common/ErrorWrapper';
import draggable from 'vuedraggable';
import ErrorsViewer from '@/components/workflows/common/ErrorsViewer';
import OutputsViewer from '@/components/workflows/common/OutputsViewer';
import ParametersComposer from '@/components/workflows/common/ParametersComposer';
import BlocksTree from '@/components/tree/BlocksTree';
import BlocksNode from '@/components/tree/BlocksNode';
import VariableFinder from "@/components/workflows/common/VariableFinder";
import {VariableFinderTrigger} from "@/directives/variable-finder-trigger";
import ReferenceInputHelper from "@/components/workflows/common/ReferenceInputHelper";
import VariableFinderOutput from "@/components/workflows/common/VariableFinderOutput";
import NotificationsCenter from "@/components/common/NotificationsCenter";
import WorkflowLog from "@/components/workflows/WorkflowLog";
import JsonEditor from "@/components/common/JsonEditor";
import Repeatable from "@/components/common/Repeatable";
import ConnectionSelector from "@/components/connections/ConnectionSelector";
import ConnectionInitializer from "@/components/connections/ConnectionInitializer";
import Multiselect from '@vueform/multiselect'
import {restApiHttpClient} from "@/helpers/rest-api-http-client";
import * as vue from 'vue';

// WP-Related
document.body.classList.add('folded');
document.getElementById('screen-meta').remove();
window.addEventListener('load', () => document.getElementById('wpfooter').remove(), false);

// Host
const host = document.querySelector('#mantiq');

// Template
const template = host.querySelector('template');
template.content.append(document.querySelector('#material-icons-css').cloneNode());
template.content.append(document.querySelector('#app-css'));

// Attach a ShadowDOM for isolation purposes
host.attachShadow({mode: 'open'}).append(template.content);

// Remove template because we don't need it anymore
template.remove();

// Get the app container
const appContainer = host.shadowRoot.querySelector('.app');

// Main app
const app = createApp(App);
window.Mantiq = app;
app.vue = vue;
// Helpers
// Config
app.config.globalProperties.$config = useConfig();
// Store
app.config.globalProperties.$store = useStore();
// HTTP
app.config.globalProperties.$http = axios;
// REST
app.config.globalProperties.$rest = restApiHttpClient;
// Time
app.config.globalProperties.$relativeTime = getRelativeTime;
// Connections
app.config.globalProperties.$connections = useConnections();

// Directives
app.directive('dragscroll', dragscrollNext);
app.component('multiselect', Multiselect);
app.component('blocks-tree', BlocksTree);
app.component('blocks-node', BlocksNode);
app.component('outputs-viewer', OutputsViewer);
app.component('parameters-composer', ParametersComposer);
app.component('errors-viewer', ErrorsViewer);
app.component('error-wrapper', ErrorWrapper);
app.component('workflow-log', WorkflowLog);
app.component('repeatable', Repeatable);
app.component('reference-input-helper', ReferenceInputHelper);
app.component('notifications-center', NotificationsCenter);
app.component('variable-finder', VariableFinder);
app.component('variable-finder-output', VariableFinderOutput);
app.directive('variable-finder-trigger', VariableFinderTrigger);
app.component('draggable', draggable);
app.component('json-editor', JsonEditor);
app.component('connection-selector', ConnectionSelector);
app.component('connection-initializer', ConnectionInitializer);

app.Connections = {
    ConnectionProvider
};

addEventListener('load', () => {
    wp.hooks.doAction('init', app);

    // Routing
    const router = createRouter({
        history: createWebHashHistory(),
        routes: ROUTES,
    });

    app.use(router);

    // Mount
    app.instance = app.mount(appContainer);

    wp.hooks.doAction('mounted', app, appContainer);
});
